import { ServiceCard, ServicesHeading, ServicesSection } from "./services-parts";
import { Button } from "../ui/button";
import React from "react";
import type { ServicesLayoutProps } from "./services-parts";
import { cn } from "../../lib/utils";
import { serviceKey } from "./services-text";

/** Two rows of three on a desktop before the rest fold away. */
const SHOWN_BEFORE_EXPANDING = 6;

/**
 * The services as a grid of cards that shows the first six and folds the rest behind a
 * Show all button. Every card stays in the page, so search engines read them all.
 * @param {ServicesLayoutProps} props The section's props.
 * @returns {React.JSX.Element} The section.
 */
const ServicesExpandable = ({ id, className, heading, subheading, services, backgroundColor }: ServicesLayoutProps): React.JSX.Element => {
  const [expanded, setExpanded] = React.useState(false);
  const shown = services ?? [];
  const folds = shown.length > SHOWN_BEFORE_EXPANDING;
  return (
    <ServicesSection id={id} className={className} backgroundColor={backgroundColor}>
      <ServicesHeading heading={heading} subheading={subheading} />
      <div data-testid="services-expandable" className="jobsite:grid jobsite:gap-5 jobsite:md:grid-cols-2 jobsite:xl:grid-cols-3">
        {shown.map((service, index) => (
          <ServiceCard
            key={serviceKey(service)}
            service={service}
            className={cn(!expanded && index >= SHOWN_BEFORE_EXPANDING && "jobsite:hidden")}
          />
        ))}
      </div>
      {folds && (
        <div className="jobsite:mt-8 jobsite:flex jobsite:justify-center">
          <Button
            data-testid="services-show-all"
            variant="outline"
            size="lg"
            aria-expanded={expanded}
            onClick={() => {
              setExpanded((previous) => !previous);
            }}
          >
            {expanded ? "Show fewer" : `Show all ${shown.length} services`}
          </Button>
        </div>
      )}
    </ServicesSection>
  );
};

export { ServicesExpandable };
